export default {
  questionId(state) {
    return state.theQuestion.id
  },

  authorId(state) {
    return state.theQuestion.author.id
  },
}
